<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'" elevation="0" class="all-trade-tab rounded-0">
    <div class="commission-settings-link">
      <router-link class="links" :to="model === 'tab-1' ? '/transaction-history'
        : model === 'tab-2' ? '/registered-user?tab=1'
          : model === 'tab-3' ? '/partner-list'
            // : model === 'tab-4' ? '/top-performed-ib'
              : ''">
        {{
          model === 'tab-1' ? 'All Transactions'
            : model === 'tab-2' ? 'All New Clients'
              : model === 'tab-3' ? 'All New Partners'
                : model === 'tab-4' ? 'See All Top IB'
                  : ''
        }}
      </router-link>

    </div>
    <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'" v-model="model">
      <v-tab v-if="$canRoute('deposit') > 0 || $canRoute('withdraw') > 0 || $canRoute('internal-transctions') > 0 || $canRoute('withdraw-requests') > 0" :href="`#tab-1`"> Transaction </v-tab>
      <v-tab v-if="$canRoute('registered-user?tab=1') > 0" :href="`#tab-2`"> New Clients</v-tab>
      <v-tab v-if="$canRoute('partner-list') > 0" :href="`#tab-3`">
        IB Request <strong>{{ dashboardibrequest?.totalPendingRequest || 0 }}</strong>
      </v-tab>
      <!-- <v-tab v-if="$canRoute('top-performed-ib') > 0" :href="`#tab-4`"> Top Performed IB</v-tab> -->

      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <DepositTab v-if="model === 'tab-1'"></DepositTab>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <NewClientsTab v-if="model === 'tab-2'"></NewClientsTab>
        </v-tab-item>
        <v-tab-item :value="`tab-3`">
          <NewPartnersTab v-if="model === 'tab-3'"></NewPartnersTab>
        </v-tab-item>
        <v-tab-item :value="`tab-4`">
          <AllTopIBTab v-if="model === 'tab-4'"></AllTopIBTab>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<script>
import { formatNumber } from "@/_helpers/formatNumber";
import { PARTNERLIST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import DepositTab from "./DepositTab.vue";
import NewClientsTab from "./NewClientsTab.vue";
import AllTopIBTab from "./AllTopIBTab.vue";
import NewPartnersTab from "./NewPartnersTab.vue";

export default {
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    DepositTab,
    NewClientsTab,
    NewPartnersTab,
    AllTopIBTab
  },
  computed: {
    ...mapState("partnerlist", ['dashboardibrequest']),
  },
  methods: {
    ...mapActions("partnerlist", [
      PARTNERLIST__ACTIONS.DASHBOARDIBREQUEST
    ]),
    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },
  },

  async created() {
    this[PARTNERLIST__ACTIONS.DASHBOARDIBREQUEST]();
  },
};
</script>
